import { createAction, props } from '@ngrx/store';

export const loadDeleteProductSolution = createAction(
  '[DeleteProductSolution] Load DeleteProductSolution',
  props<{ productSolutionId: string }>()
);

export const loadDeleteProductSolutionSuccess = createAction(
  '[DeleteProductSolution] Load DeleteProductSolution Success',
  props<{ productSolutionId: string }>()
);

export const loadDeleteProductSolutionFailure = createAction(
  '[DeleteProductSolution] Load DeleteProductSolution Failure',
  props<{ error: any }>()
);
